import { Link } from 'react-router-dom';

export default function NeedToKnow() {
  const leftPoints = [
    'All standard tents use the same purpose-developed, UV-stabilised fabric as our custom range.',
    'Fully waterproof and rated to handle wind, rain, and direct sun.',
    'Fabric is mould-resistant and fade-treated for long-term outdoor use.',
    'Easy to clean: simply hose down and lightly scrub.',
  ];

  const rightPoints = [
    'Standard sizes can be linked together using our joining system for unlimited coverage.',
    'Upgrade to a fully custom size, shape, or custom printed skin at any time.',
    'Available in a wide range of colours, from bright tones to earthy neutrals.',
  ];

  const swatches = [
    { hex: '#FFFFFF', border: true },
    { hex: '#9E9E9E', border: false },
    { hex: '#36454F', border: false },
    { hex: '#A89080', border: false },
    { hex: '#C49A5A', border: false },
    { hex: '#C6E832', border: false },
    { hex: '#A8B87A', border: false },
    { hex: '#2ECC40', border: false },
    { hex: '#1B5E3B', border: false },
    { hex: '#00D4D4', border: false },
    { hex: '#1A44CC', border: false },
    { hex: '#F5D000', border: false },
    { hex: '#F47B20', border: false },
    { hex: '#E8192C', border: false },
    { hex: '#800020', border: false },
    { hex: '#FF2D9B', border: false },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <h2 className="text-3xl md:text-4xl font-light text-center text-gray-800 mb-4">
          What you <strong className="font-bold">need to know</strong>
        </h2>
        <p className="text-center text-gray-500 text-sm mb-14 max-w-xl mx-auto">
          Need a larger footprint or a completely bespoke solution? Our custom range has you covered.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-6">
          {/* Left column */}
          <ul className="space-y-5">
            {leftPoints.map((point) => (
              <li key={point} className="flex items-start gap-3">
                <span className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-500 text-base" />
                </span>
                <span className="text-sm text-gray-600 leading-relaxed">{point}</span>
              </li>
            ))}
          </ul>

          {/* Right column */}
          <ul className="space-y-5">
            {rightPoints.map((point) => (
              <li key={point} className="flex items-start gap-3">
                <span className="mt-1 w-4 h-4 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-teal-500 text-base" />
                </span>
                <span className="text-sm text-gray-600 leading-relaxed">{point}</span>
              </li>
            ))}
            {/* Colour swatches */}
            <li className="flex items-center gap-2 pt-1 flex-wrap">
              {swatches.map((swatch, i) => (
                <span
                  key={`swatch-${swatch.hex}-${i}`}
                  className={`w-5 h-5 rounded-full flex-shrink-0 ${swatch.border ? 'border border-gray-300' : ''}`}
                  style={{ backgroundColor: swatch.hex }}
                />
              ))}
            </li>
          </ul>
        </div>

        {/* Upgrade callout */}
        <div className="mt-14 bg-gray-50 rounded-2xl p-8 md:p-10">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
            {[
              {
                icon: 'ri-expand-diagonal-line',
                title: 'Custom Sizes',
                desc: 'Need a specific footprint? We manufacture to any dimension. No size is too large or too unusual.',
              },
              {
                icon: 'ri-link-m',
                title: 'Joining Systems',
                desc: 'Connect multiple standard tents together seamlessly to create vast, uninterrupted covered spaces.',
              },
              {
                icon: 'ri-paint-brush-line',
                title: 'Custom Printed Skins',
                desc: 'Upgrade to a custom printed skin for maximum visual impact at festivals and corporate events.',
              },
            ].map((item) => (
              <div key={item.title} className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center bg-teal-50 rounded-xl flex-shrink-0">
                  <i className={`${item.icon} text-teal-500 text-lg`} />
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 text-sm mb-1">{item.title}</h4>
                  <p className="text-xs text-gray-500 leading-relaxed">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/products/custom-stretch-tents"
              className="inline-flex items-center gap-2 text-sm font-semibold text-white bg-teal-500 hover:bg-teal-600 px-7 py-3 rounded-md transition-colors whitespace-nowrap cursor-pointer"
            >
              See Custom Stretch Tents
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line" />
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
